<template>
  <div class="flex items-center justify-between">
    <h1 class="p-4 font-bold capitalize"><slot /></h1>
    <div v-if="$slots.actions" class="header-actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup></script>
